export interface IntegrationStatusConstructor {
  integrationConnections: {
    netsuiteV2: boolean
    punchout: boolean
    quickbooks: boolean
    quickbooksOnline: boolean
    slack: boolean
    stripe: boolean
  }
  slackIntegration: {
    slackRedirectUrl: string
    slackState: string
  }
}

export class IntegrationStatus {
  public readonly integrationConnections: {
    netsuiteV2: boolean
    punchout: boolean
    quickbooks: boolean
    quickbooksOnline: boolean
    slack: boolean
    stripe: boolean
  }
  public readonly slackIntegration: {
    slackRedirectUrl: string
    slackState: string
  }

  constructor(data: IntegrationStatusConstructor) {
    this.integrationConnections = {
      netsuiteV2: data.integrationConnections.netsuiteV2,
      punchout: data.integrationConnections.punchout,
      quickbooks: data.integrationConnections.quickbooks,
      quickbooksOnline: data.integrationConnections.quickbooksOnline,
      slack: data.integrationConnections.slack,
      stripe: data.integrationConnections.stripe,
    }
    this.slackIntegration = {
      slackRedirectUrl: data.slackIntegration.slackRedirectUrl,
      slackState: data.slackIntegration.slackState,
    }
  }

  get isSlackIntegrated(): boolean {
    return this.integrationConnections.slack
  }

  get slackOAuthUrl(): string {
    const baseUrl = 'https://slack.com/oauth/authorize'
    // Strip Angular hash-based routing prefix (/#/) for React router compatibility
    const reactRedirectUrl = this.slackIntegration.slackRedirectUrl.replace(
      '/#/',
      '/'
    )
    const params = new URLSearchParams({
      scope: 'bot,users:read,chat:write:bot',
      client_id: '2307800569.18464518800',
      redirect_uri: reactRedirectUrl,
      state: this.slackIntegration.slackState,
    })
    return `${baseUrl}?${params.toString()}`
  }
}
